__webpack_require__.p = "/football-mania/";